import { useState } from 'react'

import Rating from '../../../../components/Rating/Rating'
import RichText from '../../../../components/RichText/RichText'

import useToggle from '../../../../hooks/useToggle'

import { getCssVar } from '../../../../utils/css'

export default function DashboardEbpcApplicationReviewRatingField (props = {
    backgroundColor: null,
    id: null,
    resource: null,
    richText: null,
    slug: null,
    title: null,
    answer: null,
    index: null,
    formId: null,
    defaultValue: null,
    disabled: null,
    onChange: null
}) {
    const {
        backgroundColor,
        id,
        resource,
        richText,
        slug,
        title,
        answer,
        index,
        formId,
        onChange,
        ...inputProps
    } = props

    const [value, setValue] = useState((inputProps || {}).defaultValue)

    const [expanded, toggleExpanded] = useToggle()

    const style = backgroundColor
        ? { padding: '30px 15px', borderRadius: 5, backgroundColor }
        : (index
            ? { borderTop: `1px solid ${getCssVar('--geyser')}` }
            : null)

    return (
        <div
            id={slug}
            className={`dashboard-ebpc-application-review-rating-field form-field margin-3-b${
                !backgroundColor
                        && index
                    ? ' pad-3-t'
                    : ''}`}
            style={style}
        >
            <div className="row-condensed flex-align-items-center flex-justify-content-space-between">
                <div className="col-auto">
                    <h3
                        id={`${formId}-rating-${slug}-title`}
                        className="body-3 font-weight-medium"
                    >
                        {title}
                    </h3>
                </div>
                <div className="col-auto">
                    <button
                        className="btn btn-sm btn-outline-secondary-alt"
                        type="button"
                        aria-expanded={Boolean(expanded)}
                        aria-controls={`${formId}-rating-${slug}`}
                        aria-label={`${expanded
                            ? 'Hide'
                            : 'Show'} input for ${title.toLowerCase()}`}
                        onClick={() => toggleExpanded(!expanded)}
                        style={{
                            backgroundColor: value
                                    && !backgroundColor
                                ? getCssVar('--porcelain')
                                : null,
                            borderColor: value
                                    && !backgroundColor
                                ? getCssVar('--porcelain')
                                : null,
                            fontSize: value
                                ? 15
                                : 12,
                            fontWeight: value
                                ? 500
                                : 300
                        }}
                    >
                        <span>{value || 'Rate'}</span>
                        <svg width="16" height="16">
                            <use xlinkHref="#icon-expand-more" />
                        </svg>
                    </button>
                </div>
            </div>
            <div
                id={`${formId}-rating-${slug}`}
                data-expanded={Boolean(expanded)}
            >
                <div>
                    <div className="rating-field margin-1-t">
                        <div className="row-condensed flex-nowrap">
                            <div
                                className="col-auto display-flex flex-align-items-center"
                                aria-hidden="true"
                            >
                                <span>Lowest</span>
                            </div>
                            <div className="col flex-shrink pad-0">
                                <Rating
                                    id={`${formId}-rating-${slug}-radiogroup`}
                                    name={slug}
                                    labelledby={`${formId}-rating-${slug}-title`}
                                    describedby={`${formId}-rating-${slug}-instructions`}
                                    values={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                                    data-resource={resource}
                                    data-resource-id={id}
                                    onChange={(e) => {
                                        setValue(e.target.value)

                                        if (typeof onChange === 'function')
                                            onChange(e)
                                    }}
                                    {...inputProps}
                                />
                            </div>
                            <div
                                className="col-auto display-flex flex-align-items-center"
                                aria-hidden="true"
                            >
                                <span>Highest</span>
                            </div>
                        </div>
                    </div>
                    <span
                        id={`${formId}-rating-${slug}-instructions`}
                        className="rating-field-instructions body-5 margin-1-t display-none-sm-up row-condensed"
                    >
                        <span className="col-auto pad-1-r">
                            <svg width="16" height="16" aria-hidden="true">
                                <use xlinkHref="#icon-info" />
                            </svg>
                        </span>
                        <span className="col pad-0-l">
                            1 is the lowest rating. 10 is the highest rating.
                        </span>
                    </span>
                </div>
            </div>
            <RichText
                className="body-4"
                html={richText}
                style={{
                    color: getCssVar(backgroundColor
                        ? '--oxford'
                        : '--navy'),
                    marginTop: 15
                }}
            />
            {answer
                && (
                    <p
                        className="body-4 margin-1-t"
                    >
                        {answer}
                    </p>)}
            {props.children}
        </div>
    )
}
